module.exports = __webpack_public_path__ + "img/icon2.797309dc.svg";